import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref, watch} from 'vue';
import {useStore} from 'vuex';
import TimelineRow from './TimelineRow.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineList',
  setup(__props) {

const store = useStore();
const isDarkMode = ref(store.state.isDarkMode);

watch(
  () => store.state.isDarkMode,
  newValue => {
    isDarkMode.value = newValue;
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["timeline mb-5", {
      light: !isDarkMode.value,
    }])
  }, [
    _createVNode(TimelineRow, {
      title: "Bachelor of Science in Information Technology",
      company: "University of Technology Sydney",
      date: "2018 - 2022",
      description: "Graduated with a major in Enterprise System Development and a minor in Game Development, with a strong focus on UI/UX. Completed two internships as part of the degree.",
      icon: "graduation-cap",
      "is-content-right": false
    }),
    _createVNode(TimelineRow, {
      title: "Full Stack Developer",
      company: "Benevolence Financial Group",
      date: "2021",
      description: "Elevated website structure, implemented new landing pages, and optimised UI/UX for an impactful digital experience. Developed custom loan calculators to help users estimate repayments with ease.",
      "is-content-right": true
    }),
    _createVNode(TimelineRow, {
      title: "Full Stack Developer",
      company: "Spaces Interactive",
      date: "2022",
      description: "Enhanced error handling and backend security for a seamless React dashboard. Collaborated on defining technical specs for project enhancements.",
      "is-content-right": false
    }),
    _createVNode(TimelineRow, {
      title: "Full Stack Developer",
      company: "Mirk",
      date: "2022 - 2023",
      description: "Led scoring system development, designed an NFT Marketplace, integrated React with Unity, managed Node backend, enhanced functionalities, implemented Firebase auth, and optimised with TypeScript.",
      "is-content-right": true
    }),
    _createVNode(TimelineRow, {
      title: "Full Stack Developer",
      company: "Quormotion",
      date: "2023 - Present",
      description: "Develop purpose-driven mobile applications and digital solutions that create meaningful impact. Lead full-stack development of client projects from concept to launch, specialising in cross-platform mobile apps. Collaborate closely with clients to understand their vision and transform ideas into robust, scalable solutions that serve real-world needs. Notable projects include Brain Twist, SMS Sender, managing everything from development to marketing strategy.",
      url: "https://quormotion.com",
      "is-content-right": false
    })
  ], 2))
}
}

})